import React, { useState, useEffect, useRef } from "react";
import * as echarts from "echarts";
import guizhou from "../../assets/guizhou.json";
import "echarts/lib/component/tooltip";
import { getMapStatics } from "../../api/map";

let myChart;
let hourIndex = 0;
let timer = null;
const DataMap = () => {
  const mapRef = useRef();

  useEffect(() => {
    getMapStatics({
      type: 1,
    }).then((res) => {
      let list = [];
      res.result &&
        res.result.map((item) => {
          list.push({ name: item.name, value: item.count });
        });
      if (mapRef.current) {
          initCharts(list);
      }
    });
   
  }, []);

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  });

  const initCharts = (mapData) => {
    myChart = echarts.init(mapRef.current);
    const option = {
      series: [
        {
          type: "map",
          mapType: "china",
          roam: "scale",
          zoom: 1.5,
          layoutCenter: ["185%", "115%"], //距离左右，上下距离的百分比
          layoutSize: "300%", //map百分比大小
          scaleLimit: {
            min: 1, //缩放最小大小
            max: 1.5, //缩放最大大小
          },
          label: {
            show: true,
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          // 地图区域的样式设置
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(144, 127, 114, .4)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(144, 127, 114, .9)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "#8f8073",
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10,
            },
            emphasis: {
              areaColor: "#c0aa90",
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              label: { show: true },
            },
          },
          data: mapData,
        },
      ],
      // 提示浮窗样式
      tooltip: {
        show: true,
        trigger: "item",
        showContent: true,
        backgroundColor: "#000",
        borderColor: "rgba(0, 0, 0, 0.16);",
        hideDelay: 100,
        triggerOn: "mousemove",
        enterable: true,
        textStyle: {
          color: "#fff",
          fontSize: "12",
          width: 120,
          height: 80,
          overflow: "break",
          textAlign: "left",
        },
        formatter(params) {
          return `${params.name}：${params.value}`+"件";
        },
        showDelay: 10,
      },
    };
    echarts.registerMap("china", guizhou);
    myChart.setOption(option);
    intervel(mapData);
    // 鼠标移入的时候 取消高亮 并且取消定时器
    myChart.on("mouseover", (params) => {
      clearInterval(timer);
      timer = "";
      myChart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: -1, // 取消高亮
      });
    });
    //鼠标移出继续轮播高亮
    myChart.on("mouseout", (params) => {
      intervel(mapData);
    });
  };

  const intervel = (mapData) => {
    timer = setInterval(() => {
      myChart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
      });
      myChart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: hourIndex,
      });
      myChart.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: hourIndex,
      });
      //如果是最后一个了就从头开始
      if (hourIndex > mapData.length) hourIndex = 0;
      else hourIndex++;
    }, 3000);
  };

  return (
    <div
      ref={mapRef}
      style={{ width: "100%", height: 610, paddingLeft: "5%" }}>
    </div>    
  );
};

export default DataMap;
